import { useFindAllOrganizationsQuery } from "@/libs/generated/hooks";
import type { FindAllOrganizationsQuery } from "@/libs/generated/operations";

export const ALL_ORGANIZATIONS_QUERY_INPUT = {
  GetAllInput: {
    pagination: { page: 0, perPage: 100_000 },
    sort: { field: "createdAt", order: "desc" as const },
    keyword: "",
  },
} as const;

export type OrganizationRecord =
  FindAllOrganizationsQuery["findAllOrganizations"]["records"][number];

/** Organizations rarely change — keep this cached longer than default. */
const ORGANIZATIONS_STALE_TIME = 30 * 60 * 1000; // 30 minutes
const ORGANIZATIONS_GC_TIME = 60 * 60 * 1000; // 1 hour

export const allOrganizationsQueryKey = useFindAllOrganizationsQuery.getKey(
  ALL_ORGANIZATIONS_QUERY_INPUT
);

export function useAllOrganizations() {
  const query = useFindAllOrganizationsQuery(ALL_ORGANIZATIONS_QUERY_INPUT, {
    staleTime: ORGANIZATIONS_STALE_TIME,
    gcTime: ORGANIZATIONS_GC_TIME,
  });

  return {
    ...query,
    organizations: query.data?.findAllOrganizations.records ?? [],
    total: query.data?.findAllOrganizations.total ?? 0,
  };
}
